import { cloneElement, CSSProperties, FC, isValidElement, ReactElement, ReactNode } from 'react';
import { Avatar } from 'antd';
import { TbChartBar } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useReportComponents } from '@/hooks/useReportComponents';
import { ReportComponentType } from '@/types';

interface ReportComponentIconProps {
    size?: number;
    style?: CSSProperties;
    type: ReportComponentType;
}

const ReportComponentIcon: FC<ReportComponentIconProps> = ({ size = 20, style, type }) => {
    const { token } = useAntDesignTheme();
    const { allReportComponents } = useReportComponents();
    const option = allReportComponents.flatMap((group) => group.options).find((item) => item.key === type);
    const icon = (option?.icon ?? <TbChartBar size='1rem' />) as ReactNode;

    if (isValidElement(icon) && icon.type === Avatar) {
        const avatar = icon as ReactElement<{ size?: number; style?: CSSProperties }>;

        return cloneElement(avatar, {
            size,
            style: {
                ...avatar.props.style,
                display: 'inline-flex',
                flex: '0 0 auto',
                verticalAlign: 'middle',
                ...style,
            },
        });
    }

    return (
        <Avatar
            aria-label={`${option?.label ?? type} icon`}
            shape='square'
            size={size}
            icon={
                <span
                    style={{
                        alignItems: 'center',
                        color: token.colorTextTertiary,
                        display: 'flex',
                        height: '100%',
                        justifyContent: 'center',
                        width: '100%',
                    }}
                >
                    {icon}
                </span>
            }
            style={{
                background: token.colorBgBase,
                border: `1px solid ${token.colorBorder}`,
                display: 'inline-flex',
                flex: '0 0 auto',
                verticalAlign: 'middle',
                ...style,
            }}
        />
    );
};

export default ReportComponentIcon;
